import Vue from 'vue';
import ActionButton from '@/components/action_button/Index.vue';
import '@/assets/stylesheets/v2/_base-page.scss';
export default Vue.extend({
    props: {
        imageUrl: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        alreadyConnected: {
            type: Boolean,
            required: false,
            default: true,
        },
        isPageConnected: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-card', { class: 'base-page' }, [
            createElement('v-layout', { class: 'column fill-height' }, [
                createElement('v-flex', { class: 'grow' }, [
                    createElement('v-layout', { class: 'align-center' }, [
                        createElement('v-flex', { class: 'shrink' }, [
                            createElement('v-avatar', {
                                class: 'avatar',
                                props: {
                                    size: '64px',
                                },
                            }, [
                                createElement('img', {
                                    class: 'image',
                                    attrs: { src: this.imageUrl },
                                }),
                            ]),
                        ]),
                        createElement('v-flex', [
                            createElement('p', { class: 'label font-weight-medium grow text-capitalize' }, [
                                this.label,
                            ]),
                            createElement('p', { class: 'status  text-capitalize' }, [
                                this.alreadyConnected ? 'Already Connected' : '',
                            ]),
                        ]),
                    ]),
                ]),
                createElement('v-flex', { class: 'shrink' }, [
                    createElement('v-card-actions', { class: 'pa-0' }, [
                        createElement('v-layout', { class: 'align-center justify-end' }, [
                            createElement(ActionButton, {
                                class: {
                                    hide: self.alreadyConnected && !self.isPageConnected,
                                    disconnect: self.alreadyConnected && self.isPageConnected,
                                    connect: !self.alreadyConnected && !self.isPageConnected,
                                },
                                style: {
                                    backgroundColor: self.alreadyConnected ? 'white' : '',
                                    color: self.alreadyConnected ? '#6fc4c9' : 'white',
                                    border: self.alreadyConnected ? `1px solid #6fc4c9` : '',
                                },
                                attrs: {
                                    'data-cy': 'page-activation-action-button',
                                },
                                props: {
                                    submit: true,
                                },
                                on: {
                                    wasClicked: () => {
                                        this.$emit('handleClick');
                                    },
                                },
                            }, this.alreadyConnected ? 'Disconnect' : 'Connect' // Set label based on condition
                            ),
                        ]),
                    ]),
                ]),
            ]),
        ]);
    },
});
